import { Controller } from "@hotwired/stimulus"
import TomSelect from 'tom-select'

export default class extends Controller {
  static values = {
    searchUrl: String,
    allowEmpty: Boolean
  }

  connect() {
    this.initializeTomSelect()
  }

  initializeTomSelect() {
    const searchUrl = this.searchUrlValue || '/brands/search.json?search[term]='

    this.tomSelect = new TomSelect(this.element, {
      valueField: 'id',
      labelField: 'text',
      searchField: [],
      diacritics: true,
      preload: true,
      closeAfterSelect: true,
      allowEmptyOption: this.allowEmptyValue,
      loadThrottle: 200,
      maxItems: 1,
      onChange: () => {
        document.activeElement.blur()
      },
      load: (query, callback) => {
        this.tomSelect.clearOptions()

        const url = searchUrl + encodeURIComponent(query)

        fetch(url)
          .then(response => response.json())
          .then(json => callback(json))
          .catch(() => callback())
      },
      render: {
        option: (item, escape) => {
          const flagPathHtml = item.flag_path ? `<img class="mr-3 w-8 object-contain" src="${item.flag_path}" />` : ''
          const crueltyFreeHtml = item.cruelty_free ? escape(item.cruelty_free) : ''

          return `<div class="py-3 font-header flex items-center border-b border-warm-gray-100 w-full">
                    <div class='flex flex-wrap py-1.5'>
                      ${flagPathHtml}
                      <div class="text-warm-gray-800 font-medium leading-none pt-0.5">
                        ${escape(item.text)}
                      </div>
                    </div>
                    <div class="ml-auto flex text-warm-gray-500 text-sm font-light">
                      ${crueltyFreeHtml}
                    </div>
                  </div>`
        },
        item: (item, escape) => {
          return `<div class="font-header text-warm-gray-800">${escape(item.text)}</div>`
        }
      }
    })
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
  }
}
